/**
 * Helpers for creating Customer Documents instance
 */

import type { IBaseCustomer } from "../../BaseCustomerFactory";
import type { Document } from "le-coffre-resources/dist/Customer";
import type { ApiPayload, QueryPayload } from "../../../../types";
import type { IGetDocumentsparams, IPutDocumentsParams } from "../Documents";
import {
	createGetMethod,
	createPostMethod,
	createGetByUidMethod,
	createPutMethod,
	createDeleteMethod,
	createMarkAsViewedMethod,
} from "./documentsMethodsHelpers";

export interface DocumentsInstance {
	get(q: IGetDocumentsparams): Promise<Document[]>;
	post(body: ApiPayload): Promise<Document>;
	getByUid(uid: string, q?: QueryPayload): Promise<Document>;
	put(uid: string, body: IPutDocumentsParams): Promise<Document>;
	delete(uid: string): Promise<Document>;
	markAsViewed(uid: string): Promise<Document>;
}

/**
 * Create Documents instance with all methods
 */
export function createDocumentsInstance(baseCustomer: IBaseCustomer): DocumentsInstance {
	const baseUrl = baseCustomer.namespaceUrl.concat("/documents");

	return {
		get: createGetMethod(baseCustomer, baseUrl),
		post: createPostMethod(baseCustomer, baseUrl),
		getByUid: createGetByUidMethod(baseCustomer, baseUrl),
		put: createPutMethod(baseCustomer, baseUrl),
		delete: createDeleteMethod(baseCustomer, baseUrl),
		markAsViewed: createMarkAsViewedMethod(baseCustomer, baseUrl),
	};
}
